import React, {useState} from 'react';

import {useI18n} from '@udemy/i18n';
import {AlertBanner} from '@udemy/react-messaging-components';

import {
    dismissPauseBanner,
    getPauseBannerContent,
    getPauseBannerState,
    isPauseBannerDismissed,
    PauseBannerPhase,
    type PauseSubscriptionEnrollment,
    SUBSCRIPTION_MANAGEMENT_LINK,
} from './pause-subscription-banner';
import styles from './pause-subscription-banner.module.less';

export interface PauseSubscriptionBannerProps {
    enrollment: PauseSubscriptionEnrollment | null;
    onReactivate?: () => void;
}

export const PauseSubscriptionBanner = ({
    enrollment,
    onReactivate,
}: PauseSubscriptionBannerProps) => {
    const {gettext, locale} = useI18n();
    const [hiddenPhase, setHiddenPhase] = useState<PauseBannerPhase | null>(null);
    const banner = getPauseBannerState(enrollment, locale);
    const visibleBanner =
        banner && banner.phase !== hiddenPhase && !isPauseBannerDismissed(banner.phase)
            ? banner
            : null;

    if (!visibleBanner) {
        return null;
    }

    const {title, description} = getPauseBannerContent(
        visibleBanner.phase,
        visibleBanner.pauseDate,
    );

    return (
        <div className={styles.banner} data-testid="pause-subscription-banner">
            <AlertBanner
                udStyle="warning"
                backgroundStyle="bordered"
                title={title}
                body={description}
                showCta={true}
                ctaText={gettext('Re-activate subscription')}
                onAction={onReactivate}
                onDismiss={() => {
                    dismissPauseBanner(visibleBanner.phase);
                    setHiddenPhase(visibleBanner.phase);
                }}
                actionButtonProps={
                    onReactivate
                        ? undefined
                        : {componentClass: 'a', href: SUBSCRIPTION_MANAGEMENT_LINK}
                }
            />
        </div>
    );
};
